"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var InvoiceFee_1 = require("./InvoiceFee");
var InvoiceLine_1 = require("./InvoiceLine");
var dayjs_1 = require("../../utilities/dayjs");
__export(require("./InvoiceFee"));
__export(require("./InvoiceTax"));
__export(require("./InvoiceLine"));
var BCXmlItem;
(function (BCXmlItem) {
    BCXmlItem["ADVANCE_SHIPMENT_NOTICE"] = "AdvanceShipmentNotice";
    BCXmlItem["ASN_HEADER"] = "ASNHeader";
    BCXmlItem["ASN_ORDER_NUMBER"] = "ASNOrderNumber";
    BCXmlItem["ASN_DETAIL"] = "ASNDetail";
    BCXmlItem["LIST_OF_ASN_ITEM_DETAIL"] = "ListOfASNItemDetail";
    BCXmlItem["ASN_ITEM_DETAIL"] = "ASNItemDetail";
    BCXmlItem["ASN_LINE_ITEM_REFERENCES"] = "ASNLineItemReferences";
    BCXmlItem["ASN_PURCHASE_ORDER_REFERENCE"] = "ASNPurchaseOrderReference";
    BCXmlItem["BUYER_ORDER_NUMBER"] = "BuyerOrderNumber";
    BCXmlItem["PURCHASE_ORDER_DATE"] = "PurchaseOrderDate";
    BCXmlItem["LIST_OF_NAME_VALUE_SET"] = "ListOfNameValueSet";
    BCXmlItem["NAME_VALUE_SET"] = "NameValueSet";
    BCXmlItem["LIST_OF_NAME_VALUE_PAIR"] = "ListOfNameValuePair";
    BCXmlItem["NAME_VALUE_PAIR"] = "NameValuePair";
    BCXmlItem["ITEM_DETAIL"] = "ASNBaseItemDetail";
    BCXmlItem["ITEM_IDENTIFIERS"] = "ItemIdentifiers";
    BCXmlItem["ITEM_DESCRIPTION"] = "ItemDescription";
    BCXmlItem["PART_NUMBERS"] = "PartNumbers";
    BCXmlItem["OTHER_ITEM_IDENTIFIERS"] = "OtherItemIdentifiers";
    BCXmlItem["PRODUCT_IDENTIFIER_CODED"] = "ProductIdentifierCoded";
    BCXmlItem["PRODUCT_IDENTIFIER_QUALIFIER_CODED"] = "ProductIdentifierQualifierCoded";
    BCXmlItem["PRODUCT_IDENTIFIER"] = "ProductIdentifier";
    BCXmlItem["SELLER_PART_NUMBERS"] = "SellerPartNumber";
    BCXmlItem["SKU"] = "PartID";
    BCXmlItem["QUANTITIES"] = "ASNQuantities";
    BCXmlItem["LIST_OF_QUANTITY_CODED"] = "ListOfQuantityCoded";
    BCXmlItem["QUANTITY_CODED"] = "QuantityCoded";
    BCXmlItem["QUANTITY_VALUE"] = "QuantityValue";
    BCXmlItem["ASN_LINE_ITEM_LIST_OF_ALLLOW_OR_CHARGE"] = "ASNLineItemListOfAllowOrCharge";
    BCXmlItem["ALLOW_OR_CHARGE"] = "AllowOrCharge";
    BCXmlItem["TYPE_OF_ALLOWANCE_OR_CHARGE"] = "TypeOfAllowanceOrCharge";
    BCXmlItem["MONETARY_VALUE"] = "MonetaryValue";
    BCXmlItem["MONETARY_AMOUNT"] = "MonetaryAmount";
    BCXmlItem["VALUE"] = "_text";
})(BCXmlItem = exports.BCXmlItem || (exports.BCXmlItem = {}));
var InvoiceStatus;
(function (InvoiceStatus) {
    InvoiceStatus["PENDING"] = "pending";
    InvoiceStatus["IN_PROGRESS"] = "inProgress";
    InvoiceStatus["COMPLETED"] = "completed";
    InvoiceStatus["CANCELLED"] = "cancelled";
})(InvoiceStatus = exports.InvoiceStatus || (exports.InvoiceStatus = {}));
var InvoicePaidStatus;
(function (InvoicePaidStatus) {
    InvoicePaidStatus["PAID"] = "paid";
    InvoicePaidStatus["UNPAID"] = "unpaid";
    InvoicePaidStatus["RETURNED"] = "returned";
})(InvoicePaidStatus = exports.InvoicePaidStatus || (exports.InvoicePaidStatus = {}));
var CreateInvoice = /** @class */ (function () {
    function CreateInvoice() {
        var _this = this;
        this.supplierId = null;
        this.title = '';
        this.taxGroup = null;
        this.orderDate = null;
        this.completeDate = null;
        this.paymentDueDate = null;
        this.paid = 0;
        this.lines = [];
        this.fees = [];
        this.isReturn = false;
        this.isEdited = false;
        this.orderNumber = null;
        this.setIsEdited = function (isEdited) {
            _this.isEdited = isEdited;
        };
        this.setTitle = function (title) {
            _this.title = title;
            _this.setIsEdited(true);
        };
        this.setOrderDate = function (orderDate) {
            _this.orderDate = orderDate;
            _this.setIsEdited(true);
        };
        this.setPaymentDueDate = function (paymentDueDate) {
            _this.paymentDueDate = paymentDueDate;
            _this.setIsEdited(true);
        };
        this.setPaid = function (paid) {
            _this.paid = paid;
            _this.setIsEdited(true);
        };
        this.setNotes = function (notes) {
            _this.notes = notes;
            _this.setIsEdited(true);
        };
        this.setLocationId = function (locationId) {
            _this.locationId = locationId;
            _this.setIsEdited(true);
        };
        this.setSupplierId = function (supplierId) {
            _this.supplierId = supplierId;
            _this.setIsEdited(true);
        };
        this.setOrderNumber = function (orderNumber) {
            _this.orderNumber = orderNumber;
        };
        this.resetLines = function () {
            _this.lines = [];
            _this.setIsEdited(true);
        };
    }
    CreateInvoice.prototype.setIsReturn = function (isReturn) {
        this.isReturn = isReturn;
        this.setIsEdited(true);
    };
    CreateInvoice.prototype.setTaxGroup = function (taxGroup) {
        this.taxGroup = taxGroup;
        this.setIsEdited(true);
    };
    // A product line contains a product ID
    CreateInvoice.prototype.addProduct = function (product) {
        var newLine = new InvoiceLine_1.CreateInvoiceLine(this);
        newLine.sku = product.sku;
        newLine.productId = product.id;
        newLine.productName = product.parentProductName ? product.parentProductName + " - " + product.name : product.name;
        newLine.productUnit = product.unit;
        newLine.isBatchTracked = product.isBatchTracked;
        newLine.price = (product.price || 0);
        this.lines.push(newLine);
        this.setIsEdited(true);
        return newLine;
    };
    CreateInvoice.prototype.addFee = function () {
        var newFee = new InvoiceFee_1.CreateInvoiceFee(this);
        this.fees.push(newFee);
        this.setIsEdited(true);
        return newFee;
    };
    CreateInvoice.prototype.removeLine = function (index) {
        this.lines.splice(index, 1);
        this.setIsEdited(true);
    };
    CreateInvoice.prototype.removeFee = function (index) {
        this.fees.splice(index, 1);
        this.setIsEdited(true);
    };
    Object.defineProperty(CreateInvoice.prototype, "subTotal", {
        get: function () {
            var _a = __read([this.lines, this.fees].map(function (x) { return x.map(function (f) { return f.total || 0; }).reduce(function (a, b) { return a + b; }, 0); }), 2), linesTotal = _a[0], feesTotal = _a[1];
            return linesTotal + feesTotal;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreateInvoice.prototype, "total", {
        get: function () {
            return this.subTotal + this.taxTotal;
        },
        enumerable: true,
        configurable: true
    });
    CreateInvoice.prototype.populate = function (invoice) {
        var _this = this;
        this.locationId = invoice.locationId;
        this.supplierId = invoice.supplierId;
        this.title = invoice.title;
        this.orderDate = invoice.orderDate ? dayjs_1.dayjs(invoice.orderDate).toDate() : null;
        this.completeDate = invoice.completeDate ? dayjs_1.dayjs(invoice.completeDate).toDate() : null;
        this.paymentDueDate = invoice.paymentDueDate ? dayjs_1.dayjs(invoice.paymentDueDate).toDate() : null;
        this.paid = invoice.paid || 0;
        this.notes = invoice.notes;
        this.lines = invoice.lines.map(function (line) {
            var newLine = new InvoiceLine_1.CreateInvoiceLine(_this, line);
            if (invoice.isReturn) {
                newLine.total = Math.abs(newLine.total);
                newLine.quantity = Math.abs(newLine.quantity || 0);
            }
            return newLine;
        });
        this.fees = invoice.fees.map(function (fee) { return new InvoiceFee_1.CreateInvoiceFee(_this, fee); });
        this.isReturn = !!invoice.isReturn;
        this.orderNumber = invoice.orderNumber;
    };
    CreateInvoice.prototype.getNetworkObject = function () {
        var _this = this;
        return {
            locationId: this.locationId,
            supplierId: this.supplierId,
            taxGroupId: this.taxGroup ? this.taxGroup.id : null,
            title: this.title,
            orderDate: this.orderDate,
            completeDate: this.completeDate,
            paymentDueDate: this.paymentDueDate,
            paid: this.paid,
            notes: this.notes,
            lines: this.lines.map(function (line) {
                var quantity = line.quantity || 0;
                var quantityReceived = line.quantityReceived;
                var total = line.total;
                if (_this.isReturn) {
                    var returnQuantity = Math.abs(line.quantity || 0) * -1;
                    quantity = returnQuantity;
                    quantityReceived = returnQuantity;
                    total = Math.abs(line.total) * -1;
                }
                return {
                    id: line.id,
                    quantity: quantity,
                    quantityReceived: quantityReceived,
                    total: total,
                    taxes: line.taxes,
                    productId: line.productId,
                    productUnit: line.productUnit,
                    productName: line.productName,
                    notes: line.notes || '',
                    isBatchTracked: line.isBatchTracked,
                    batches: line.batches,
                    lot: line.lot,
                };
            }),
            fees: this.fees.map(function (fee) { return ({
                name: fee.name,
                total: fee.total,
                notes: fee.notes,
                taxes: fee.taxes,
                isTaxEnabled: fee.taxEnabled,
            }); }),
            total: this.total,
            isReturn: this.isReturn,
            orderNumber: this.orderNumber,
        };
    };
    Object.defineProperty(CreateInvoice.prototype, "taxTotal", {
        get: function () {
            var _a = __read([this.lines, this.fees].map(function (x) { return x.reduce(function (a, b) { return a + b.taxTotal; }, 0); }), 2), lineTaxesTotal = _a[0], feeTaxesTotal = _a[1];
            return lineTaxesTotal + feeTaxesTotal;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreateInvoice.prototype, "totalUnitCount", {
        get: function () {
            return this.lines.reduce(function (prev, curr) { return prev + (curr.quantityReceived || 0); }, 0);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreateInvoice.prototype, "productsWithZeroCostPerUnit", {
        get: function () {
            return this.lines.filter(function (line) { return line.costPerUnit === 0; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreateInvoice.prototype, "productsWithNoQtyReceived", {
        get: function () {
            return this.lines.filter(function (line) { return line.quantityReceived === null || line.quantityReceived === undefined; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreateInvoice.prototype, "productsWithNegativeMargin", {
        get: function () {
            return this.lines.filter(function (line) { return line.costPerUnit > line.price; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreateInvoice.prototype, "isTaxGroupSelected", {
        get: function () {
            return this.taxGroup !== null;
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        mobx_1.observable
    ], CreateInvoice.prototype, "locationId", void 0);
    __decorate([
        mobx_1.observable
    ], CreateInvoice.prototype, "supplierId", void 0);
    __decorate([
        mobx_1.observable
    ], CreateInvoice.prototype, "title", void 0);
    __decorate([
        mobx_1.observable
    ], CreateInvoice.prototype, "taxGroup", void 0);
    __decorate([
        mobx_1.observable
    ], CreateInvoice.prototype, "orderDate", void 0);
    __decorate([
        mobx_1.observable
    ], CreateInvoice.prototype, "completeDate", void 0);
    __decorate([
        mobx_1.observable
    ], CreateInvoice.prototype, "paymentDueDate", void 0);
    __decorate([
        mobx_1.observable
    ], CreateInvoice.prototype, "paid", void 0);
    __decorate([
        mobx_1.observable
    ], CreateInvoice.prototype, "notes", void 0);
    __decorate([
        mobx_1.observable
    ], CreateInvoice.prototype, "lines", void 0);
    __decorate([
        mobx_1.observable
    ], CreateInvoice.prototype, "fees", void 0);
    __decorate([
        mobx_1.observable
    ], CreateInvoice.prototype, "isReturn", void 0);
    __decorate([
        mobx_1.observable
    ], CreateInvoice.prototype, "isEdited", void 0);
    __decorate([
        mobx_1.observable
    ], CreateInvoice.prototype, "orderNumber", void 0);
    __decorate([
        mobx_1.action
    ], CreateInvoice.prototype, "setIsEdited", void 0);
    __decorate([
        mobx_1.action
    ], CreateInvoice.prototype, "setTitle", void 0);
    __decorate([
        mobx_1.action
    ], CreateInvoice.prototype, "setOrderDate", void 0);
    __decorate([
        mobx_1.action
    ], CreateInvoice.prototype, "setPaymentDueDate", void 0);
    __decorate([
        mobx_1.action
    ], CreateInvoice.prototype, "setPaid", void 0);
    __decorate([
        mobx_1.action
    ], CreateInvoice.prototype, "setNotes", void 0);
    __decorate([
        mobx_1.action
    ], CreateInvoice.prototype, "setLocationId", void 0);
    __decorate([
        mobx_1.action
    ], CreateInvoice.prototype, "setSupplierId", void 0);
    __decorate([
        mobx_1.action
    ], CreateInvoice.prototype, "setOrderNumber", void 0);
    __decorate([
        mobx_1.action
    ], CreateInvoice.prototype, "setIsReturn", null);
    __decorate([
        mobx_1.action
    ], CreateInvoice.prototype, "setTaxGroup", null);
    __decorate([
        mobx_1.action
    ], CreateInvoice.prototype, "addProduct", null);
    __decorate([
        mobx_1.action
    ], CreateInvoice.prototype, "addFee", null);
    __decorate([
        mobx_1.action
    ], CreateInvoice.prototype, "removeLine", null);
    __decorate([
        mobx_1.action
    ], CreateInvoice.prototype, "resetLines", void 0);
    __decorate([
        mobx_1.action
    ], CreateInvoice.prototype, "removeFee", null);
    __decorate([
        mobx_1.computed
    ], CreateInvoice.prototype, "subTotal", null);
    __decorate([
        mobx_1.computed
    ], CreateInvoice.prototype, "total", null);
    __decorate([
        mobx_1.action
    ], CreateInvoice.prototype, "populate", null);
    __decorate([
        mobx_1.computed
    ], CreateInvoice.prototype, "taxTotal", null);
    __decorate([
        mobx_1.computed
    ], CreateInvoice.prototype, "totalUnitCount", null);
    __decorate([
        mobx_1.computed
    ], CreateInvoice.prototype, "productsWithZeroCostPerUnit", null);
    __decorate([
        mobx_1.computed
    ], CreateInvoice.prototype, "productsWithNoQtyReceived", null);
    __decorate([
        mobx_1.computed
    ], CreateInvoice.prototype, "productsWithNegativeMargin", null);
    __decorate([
        mobx_1.computed
    ], CreateInvoice.prototype, "isTaxGroupSelected", null);
    return CreateInvoice;
}());
exports.CreateInvoice = CreateInvoice;
var InvoiceProductCostHistoryFilter = /** @class */ (function () {
    function InvoiceProductCostHistoryFilter(limit) {
        var _this = this;
        this.limit = 30;
        this.offset = 0;
        this.setProductId = function (productId) {
            _this.productId = productId;
        };
        this.setLimit = function (limit) {
            _this.limit = limit;
        };
        this.setOffset = function (offset) {
            _this.offset = offset;
        };
        if (limit)
            this.limit = limit;
    }
    __decorate([
        mobx_1.observable
    ], InvoiceProductCostHistoryFilter.prototype, "productId", void 0);
    __decorate([
        mobx_1.observable
    ], InvoiceProductCostHistoryFilter.prototype, "limit", void 0);
    __decorate([
        mobx_1.observable
    ], InvoiceProductCostHistoryFilter.prototype, "offset", void 0);
    __decorate([
        mobx_1.action
    ], InvoiceProductCostHistoryFilter.prototype, "setProductId", void 0);
    __decorate([
        mobx_1.action
    ], InvoiceProductCostHistoryFilter.prototype, "setLimit", void 0);
    __decorate([
        mobx_1.action
    ], InvoiceProductCostHistoryFilter.prototype, "setOffset", void 0);
    return InvoiceProductCostHistoryFilter;
}());
exports.InvoiceProductCostHistoryFilter = InvoiceProductCostHistoryFilter;
//# sourceMappingURL=index.js.map